@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.login.login_ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.login.login_ui.generated.resources/"

@delegate:ResourceContentHash(842_475_100)
internal val Res.drawable.ic_eye_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_eye_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_eye_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_897_008_202)
internal val Res.drawable.ic_eye_off_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_eye_off_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_eye_off_24.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_eye_24", Res.drawable.ic_eye_24)
  map.put("ic_eye_off_24", Res.drawable.ic_eye_off_24)
}
